"use strict";
const React = require('react');
const react_redux_1 = require('react-redux');
const react_router_1 = require('react-router');
const redux_auth_wrapper_1 = require('redux-auth-wrapper');
const App_1 = require('./components/App');
const LoginScreen_1 = require('./components/LoginScreen');
const RunningTaskScreen_1 = require('./components/RunningTaskScreen');
const TasksScreen_1 = require('./components/TasksScreen');
const TaskScreen_1 = require('./components/TaskScreen');
const routes = require('./utils/routes');
const UserIsAuthenticated = redux_auth_wrapper_1.UserAuthWrapper({
    authSelector: (state) => state.auth.user,
    failureRedirectPath: routes.login(),
    wrapperDisplayName: 'UserIsAuthenticated',
});
const Authenticated = UserIsAuthenticated((props) => props.children);
exports.createRouter = (store, history) => React.createElement(react_redux_1.Provider, {store: store}, 
    React.createElement(react_router_1.Router, {history: history}, 
        React.createElement(react_router_1.Route, {path: routes.tasks(), component: App_1.default}, 
            React.createElement(react_router_1.Route, {component: Authenticated}, 
                React.createElement(react_router_1.IndexRoute, {component: TasksScreen_1.default}), 
                React.createElement(react_router_1.Route, {path: routes.task(':taskId'), component: TaskScreen_1.default}), 
                React.createElement(react_router_1.Route, {path: routes.runningTask(':taskId'), component: RunningTaskScreen_1.default})), 
            React.createElement(react_router_1.Route, {path: routes.login(), component: LoginScreen_1.default}))
    )
);



/** WEBPACK FOOTER **
 ** ./src/router.tsx
 **/